import { IterableDict } from '@/helpers/IterableDict';
import { prefixedKeys } from '@/helpers/QueryStringParameters';
export function iterableDict(data) {
    return new IterableDict(Object.entries(data));
}
/**
 * TODO Replace uses of Object.entries() ... fromPairs() with this.
 */
export function mapEntries(data, callback) {
    return iterableDict(data).map(callback).toObject();
}
/**
 * TODO Replace uses of Object.entries() ... fromPairs() with this.
 */
export function filterEntries(data, callback) {
    return iterableDict(data).filter(callback).toObject();
}
export function filterNamespacedProperties(prefix, data) {
    // TODO Use filterEntries and simplify;
    // const keys = new Set(prefixedKeys(prefix, data))
    // return filterEntries(data, (value, key) => keys.has(key))
    const result = {};
    prefixedKeys(prefix, data).forEach((key) => {
        const name = key.slice(prefix.length);
        result[name] = data[key];
    });
    return result;
}
export function dictToMap(data, keys) {
    const entries = Object.entries(data).map(([id, value]) => {
        return [keys[id], value];
    });
    return new Map(entries);
}
